import styled from "styled-components";

export const CellWrapper = styled.div`
  width: ${({ $width }) => $width}px;
  flex-shrink: 0;
  padding: 14px 10px;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const CellValue = styled.span`
  font-size: 11.5px;
  font-weight: 600;
  color: var(--ink-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-sans);
`;

export const CellEmpty = styled.span`
  font-size: 11px;
  color: var(--ink-4);
  font-style: italic;
`;

export const DraftValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  font-family: var(--font-mono);
  background: #fef3c7;
  color: #b45309;
  border: 1px solid #fde68a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;
